'use strict';

var React = require('react');

var SvgImagesIcon = function SvgImagesIcon(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    viewBox: "0 0 20 20"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M14.25 9.25c0 .552-.448 1-1 1s-1-.448-1-1 .448-1 1-1 1 .448 1 1Z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M6.25 3.5c-1.519 0-2.75 1.231-2.75 2.75v5c0 1.438 1.104 2.618 2.51 2.74.122 1.406 1.302 2.51 2.74 2.51h5c1.519 0 2.75-1.231 2.75-2.75v-5c0-1.438-1.104-2.618-2.51-2.74-.122-1.406-1.302-2.51-2.74-2.51h-5Zm6.225 2.5h-3.725c-1.519 0-2.75 1.231-2.75 2.75v3.725c-.57-.116-1-.62-1-1.225v-5c0-.69.56-1.25 1.25-1.25h5c.605 0 1.11.43 1.225 1Zm1.275 1.5c.69 0 1.25.56 1.25 1.25v1.94l-1.75 1.75-2.695-2.696c-.728-.728-1.923-.673-2.582.117l-.473.567v-1.678c0-.69.56-1.25 1.25-1.25h5Zm-6.25 5.271 1.625-1.95c.094-.113.265-.12.369-.016l3.226 3.225c.293.293.768.293 1.06 0l1.22-1.22v.94c0 .69-.56 1.25-1.25 1.25h-5c-.69 0-1.25-.56-1.25-1.25v-.979Z"
  }));
};
SvgImagesIcon.displayName = "ImagesIcon";

exports.SvgImagesIcon = SvgImagesIcon;
